import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#656E89",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M12.25 4.083v5.834c0 1.75-.875 2.916-2.917 2.916H4.667c-2.042 0-2.917-1.166-2.917-2.916V4.083c0-1.75.875-2.916 2.917-2.916h4.666c2.042 0 2.917 1.166 2.917 2.916Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#656E89",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5",
      d: "M8.458 2.625v1.167a1.17 1.17 0 0 0 1.167 1.166h1.167M4.667 7.583H7M4.667 9.917h4.666"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "loading-report-doc"}) } }